const PicabooConstants = Object.freeze({
  PAGE: {
    UNSCALED_PAGE_WIDTH: 584,
  },
  DEFAULT_BASE_PAGE_COUNT: 20,
  MINIMUM_TRADEBOOK_PAGE_COUNT: 26,
  DEFAULT_TRADEBOOK_PAGE_COUNT: 74,
  DEFAULT_RT_CAPTION: 'Click to add text',
  MIN_FONT_SIZE: 9,
  SOFT_COVER_SPINE_PAGES: 70,

  LAYFLAT_PAPER_TYPES: {
    LFEGG: 'LFEGG',
    LFPLS: 'LFPLS',
    LFPRL: 'LFPRL',
  },

  PRODUCT_TYPES: {
    BOOK: 0,
    CARD: 1,
    CALENDAR: 2,
    COLLAGE: 3,
    PRINTS: 4,
    CANVAS: 5,
    PHOTO_PANEL: 6,
    YEARBOOK: 7,
    PERSONALIZED_YEARBOOK: 8,
    PHONE_CASE: 9,
    METAL_PRINT: 10,
    SQUARE_PRINT: 11,
    MOUSE_PAD: 12,
    NOTEBOOK: 13,
    JOURNAL: 14,
    BLANKET: 15,
    PILLOW: 16,
    TOTE: 17,
    PLAYING_CARDS: 18,
    CRYSTAL: 19,
    KABOOK: 20,
    ORNAMENT: 21,
    COASTER: 22,
    MUG: 23,
    PUZZLE: 24,
    PHOTO_POSTER: 25,
    FRAME: 26,
    GIFT_CARD: 51,
    YEARBOOK_AD: 90,
  },

  PRODUCT_TYPES_META_DATA: function (productType) {
    let defaultMeta = {
      NUMBER_OF_PAGES_PER_SPREAD: 2,
      PAGE_NAME: 'Page',
      PAGE_NAME_PLURAL: 'Pages',
    };
    switch (productType) {
      case this.PRODUCT_TYPES.PRINTS:
        return {
          NUMBER_OF_PAGES_PER_SPREAD: 1,
          PAGE_NAME: 'Print',
          PAGE_NAME_PLURAL: 'Prints',
        };
    }

    return defaultMeta;
  },

  PRODUCT_SUBTYPE: {
    PHOTOBOOK: 0,
    LAYFLAT_PHOTOBOOK: 1,
    TRADEBOOK: 2,
  },

  PRODUCT_SUBTYPES: [
    { pk: 0, description: 'PhotoBook' },
    { pk: 1, description: 'LayflatPhotoBook' },
    { pk: 2, description: 'TradeBook' },
  ],

  // only ones we care about...
  SKU: {
    CLASSIC_HARDCOVER_14x11: 'PBCXHNC',
    CLASSIC_HARDCOVER_14x11_LF: 'PBCXHNCP',
    CLASSIC_HARDCOVER_14x11_SLF: 'PBCXUNC',
    CLASSIC_HARDCOVER_11x9: 'PBCLHNC',
    CLASSIC_HARDCOVER_11x9_LF: 'PBCLHNCP',
    CLASSIC_HARDCOVER_11x9_SLF: 'PBCLUNC',
    CLASSIC_SOFTCOVER_11x9: 'PBCLSNC',
    CLASSIC_HARDCOVER_8x6: 'PBCMHNC',
    CLASSIC_SOFTCOVER_8x6: 'PBCMSNC',
    MINIBOOK_5x4: 'PBCSSNC',
    MINIBOOK_5x4_SLF: 'PBCSUNC',

    CLASSIC_HARDCOVER_12x12: 'PBQXHNC',
    CLASSIC_HARDCOVER_12x12_LF: 'PBQXHNCP',
    CLASSIC_HARDCOVER_12x12_SLF: 'PBQXSNC',
    CLASSIC_HARDCOVER_8x8: 'PBQMHNC',
    CLASSIC_HARDCOVER_8x8_LF: 'PBQMHNCP',
    CLASSIC_HARDCOVER_8x8_SLF: 'PBQMSNC',
    MINIBOOK_5x5: 'PBQSSNC',
    MINIBOOK_5x5_SLF: 'PBQSUNC',
  },

  COLORS: {
    PICABLOO: '#3069b3',
    ACCENT: '#DD8132',
    SPINE_STROKE_COLOR: '#AF3636',
    DUSTFLAP_STROKE_COLOR: '#EAEBED',
    SAFETY_COLOR: {
      STROKE_COLOR: '#AF3636',
      STROKE_TRANSPARENCY: 0.8,
      SAFETY_STROKE_COLOR: '#863686',
      SAFETY_STROKE_TRANSPARENCY: 0.2,
      WRAP_STROKE_COLOR: '#737373',
      WRAP_STROKE_TRANSPARENCY: 0.1,
    },
  },

  PRINT_ORIENTATION: {
    PORTRAIT: 'Portrait',
    LANDSCAPE: 'Landscape',
    SQUARE: 'Square',
  },

  IMAGE_ORIENTATION: {
    LEFT: 8,
    RIGHT: 6,
    UPSIDE_DOWN: 3,
    DEFAULT: 1,
  },

  IMAGE_TYPES: {
    STICKER: 's',
    BACKGROUND: 'b',
    NORMAL: 'n',
    PORTRAIT: 'p',
    QR_CODE: 'q',
    AD_THUMBNAIL: 'a', //used only for drag and drop
  },

  IMAGE_RESOLUTIONS: {
    THUMB: 'thumbPath',
    WORK: 'workPath',
    HIGH: 'highResPath',
    ORIGINAL: 'originalPath',
  },

  ITEM_TYPES: {
    GRAPHICITEM: 'graphicItem',
    CAPTION: 'caption',
    SHAPE: 'shape',
    LINE: 'line',
    NAMES: 'names',
    RICH_TEXT: 'richText',
    ENGRAVING: 'engraving',
    INDEX_COLUMN: 'indexColumn',
    PARENT_AD: 'parentAd',
  },

  PAGE_TYPES: {
    NORMAL: 'P',
    COVER: 'C',
    CALENDAR_GRID: 'G',
    YEARBOOK_PORTRAIT: 'Y',
    ENVELOPE: 'E',
    INDEX: 'I',
    AD: 'A',
  },

  THEME_PAGE_TYPES: {
    FRONT: 'F',
    MIDDLE: 'M',
    BACK: 'B',
  },

  SECTION_TYPES: {
    TYPE_UNKNOWN: 0,
    TYPE_THEMED: 2,
    TYPE_COVER: 3,
    TYPE_OTHER_IMAGES: 4,
    TYPE_PORTRAIT: 5,
    TYPE_SOFTCOVER: 6,
    TYPE_INDEX: 7,
    TYPE_AD: 9,
    // until themes are ready the type is also called Freeform
    TYPE_FREEFORM: 2,
  },

  WELL_TYPES: {
    NORMAL: 'N',
    FIXED_ELEMENT: 'D',
    INTERACTIVE_ELEMENT: 'E',
    STOCK: 'S',
    ALWAYS_ON_TOP: 'T',
  },

  MASK_TYPE: {
    NONE: '',
    CIRCLE: 'circle',
    HEART: 'heart',
    STAR: 'star',
  },

  ZOOM_LEVEL: {
    FIT_PAGE: 0,
    FIT_WIDTH: 1,
    FIT_HEIGHT: 2,
  },

  SPECIAL_OPS: {
    NONE: 0x00,
    DESIGNER_ARTWORK: 0x01, // 1
    DESIGNER_ADMIN: 0x02, // 2
    CS_VIEW: 0x04, // 4
    CS_EDIT: 0x08, // 8
    CS_ADMIN: 0x10, // 16
    FEATURE_ONE: 0x20, // 32
    FEATURE_TWO: 0x40, // 64
    FEATURE_THREE: 0x80, // 128
    IMPERSONATING: 0x100, // 256
    ADMIN: 0x200, // 512
  },

  PREFERENCES: {
    ALWAYS: 'always',
    NEVER: 'never',
    PROMPT: 'prompt',
  },

  PREFERENCE_NAME: {
    RECENTLY_USED_BACKGROUNDS: 'recentlyUsedBackgrounds',
    RECENTLY_USED_COLORS: 'recentlyUsedColors',
    SORT_PHOTOS_BY_DATE_TAKEN: 'sortPhotosByDateTaken',
    SPINE_SHIFT_WARNING_SEEN: 'spineShiftWarningSeen', // list of numeric project ids
  },

  CAPTION_VERSION: {
    //PDF: 0,
    RICHTEXT: 1,
  },

  PERSONALIZED_STATUS: {
    HIDDEN: 0,
    NOT_STARTED: 1,
    IN_PROGRESS: 2,
    FINALIZED: 3,
    CANCELLED: 4,
    DELETED: 5,
    IMMEDIATE_ORDER: 6,
  },

  ROLE_NAMES: {
    GENERAL_PARTNER: 'General Partner',
    WHITE_LABEL_OWNER: 'Rep',
    ADVISOR: 'Adviser',
    SR_EDITOR: 'Sr. Editor',
    EDITOR: 'Editor',
    PHOTO_EDITOR: 'Photo Editor',
    VIEWER: 'Viewer',
  },

  ORDER_TYPES: {
    NONE: 0,
    PRE_ORDER: 1,
    IMMEDIATE: 2,
  },

  CONTRIBUTED_PHOTO_STATUS: {
    PENDING_APPROVAL: { label: 'Pending', value: '0' },
    APPROVED: { label: 'Approved', value: '1' },
    DENIED: { label: 'Denied', value: '2' },
  },

  AD_TYPES: {
    FULL_PAGE: 1,
    HALF_PAGE: 2,
    QUARTER_PAGE: 3,
    EIGHTH_PAGE: 4,
    SIXTEENTH_PAGE: 5,
  },

  AD_STATUS: {
    PENDING_APPROVAL: { label: 'Pending', value: 1 },
    APPROVED: { label: 'Approved', value: 2 },
    DENIED: { label: 'Denied', value: 3 },
    IN_BOOK: { label: 'IN BOOK', value: 4 },
    PURCHASED_LOVE_LINES: { label: 'Love Lines', value: 5 },
  },

  MANAGEMENT_TYPES: {
    SECTIONS: '0',
    LADDER: '1',
  },
  VERSION: {
    MIN_ZOOM: 100,
  },

  PAGE_ITEM_TYPES: {
    RICH_TEXT: 'richText',
    GRAPHIC_ITEM: 'graphicItem',
  },

  IMAGE_SOURCE: {
    CUSTOMER: 'customer',
    DROPBOX: 'dropbox',
    GOOGLE_PHOTOS: 'google_photos',
  },

  ADD_PAGES_LAYOUT_TYPE: {
    ONE_PAGE: 0,
    TWO_PAGE: 1,
    RANDOM: 2,
  },

  LOGO_UPGRADE: {
    NONE: 'custom',
    WHITE: 'white',
    BLACK: 'black',
  },

  // patterns for notebooks
  PAGE_BACKGROUND_PATTERNS: {
    COLLEGE_RULE: 'college_rule',
    NARROW_RULE: 'narrow_rule',
    WIDE_RULE: 'wide_rule',
    GRID_LINES: 'grid_lines',
    GRID_DOTS: 'grid_dots',
    STROKE_COLOR: '#C2C2C2',
  },
  PROJECT_SORT: {
    ALPHABETICAL_A_TO_Z: 'alphabetical_a_to_z',
    ALPHABETICAL_Z_TO_A: 'alphabetical_z_to_a',
    NEWEST_TO_OLDEST: 'newest_to_oldest',
    OLDEST_TO_NEWEST: 'oldest_to_newest',
    IMAGE_COUNT_HIGH_TO_LOW: 'image_count_high_to_low',
    IMAGE_COUNT_LOW_TO_HIGH: 'image_count_low_to_high',
  },
  PROJECT_CARD_MODE: {
    SELECTION: 'selection',
    LIBRARY: 'library',
    PREVIOUS_PROJECT_IMAGES: 'previous_project_images',
    SELECT_PHOTOS: 'select_photos',
  },
});

PicabooConstants.ROLE_NAMES.toString = function (roleName) {
  switch (roleName) {
    case this.GENERAL_PARTNER:
      return 'generalPartner';
    case this.WHITE_LABEL_OWNER:
      return 'whiteLabelOwner';
    case this.ADVISOR:
      return 'advisor';
    case this.SR_EDITOR:
      return 'senioreditor';
    case this.EDITOR:
      return 'editor';
    case this.PHOTO_EDITOR:
      return 'photoeditor';
    case this.VIEWER:
      return 'viewer';
    default:
      return '';
  }
};

PicabooConstants.PRODUCT_TYPES.toString = function (productType) {
  switch (productType) {
    case this.BOOK:
      return 'Book';
    case this.CARD:
      return 'Card';
    case this.CALENDAR:
      return 'Calendar';
    case this.COLLAGE:
      return 'Collage';
    case this.PRINTS:
      return 'Prints';
    case this.CANVAS:
      return 'Canvas';
    case this.PHOTO_PANEL:
      return 'Photo_Panel';
    case this.METAL_PRINT:
      return 'Metal Print';
    case this.YEARBOOK:
      return 'Yearbook';
    case this.PERSONALIZED_YEARBOOK:
      return 'Personalized_Yearbook';
    case this.PHONE_CASE:
      return 'Phone_Case';
    case this.FRAME:
      return 'Frame';

    case this.SQUARE_PRINT:
      return 'Scrapbook_Pages';
    case this.MOUSE_PAD:
      return 'Mouse_Pads';
    case this.NOTEBOOK:
      return 'Notebook';
    case this.JOURNAL:
      return 'Journal';
    case this.BLANKET:
      return 'Blanket';
    case this.PILLOW:
      return 'Pillow';
    case this.TOTE:
      return 'Tote_Bag';
    case this.PLAYING_CARDS:
      return 'Playing_Cards';
    case this.CRYSTAL:
      return 'Crystal';
    case this.PUZZLE:
      return 'Puzzle';
    case this.PHOTO_POSTER:
      return 'Photo Poster';
  }
};

module.exports = PicabooConstants;
